import { render, staticRenderFns } from "./CreateFromItem.vue?vue&type=template&id=6b24b75d"
import script from "./CreateFromItem.vue?vue&type=script&lang=js"
export * from "./CreateFromItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports